import React, { useState } from "react";
import {
  Typography,
  Box,
  Grid,
  Button,
  IconButton,
  Tooltip,
} from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ShareIcon from "@mui/icons-material/Share";
import CallIcon from "@mui/icons-material/Call";
import DirectionsIcon from "@mui/icons-material/Directions";
import styles from "./Location.module.css";

const address = "35, Prem Nagar 1, Gujar Ki Thadi, Jaipur - ";
const mapsLink = "https://goo.gl/maps/QVdWjz9PQH4d8yjr6";

const Location = () => {
  const [copyTooltip, setCopyTooltip] = useState("Copy");

  const handleCopy = () => {
    navigator.clipboard.writeText(`${address} - ${mapsLink}`);
    setCopyTooltip("Copied!");
    setTimeout(() => setCopyTooltip("Copy"), 1500);
  };

  const handleShare = async () => {
    try {
      await navigator.share({
        title: "Our Location",
        text: address,
        url: mapsLink,
      });
    } catch (err) {
      console.error("Share failed:", err);
    }
  };

  return (
    <Box className={styles.aboutSection}>
      <Grid item xs={12} md={6}>
        <div className={styles.mapWrapper}>
          <div className={styles.overlayPanel}>
            <Typography variant="subtitle1" fontWeight="bold">
              Our Location
            </Typography>
            <Typography variant="body2">{address}</Typography>

            <Box mt={1} display="flex" flexWrap="wrap" gap={1}>
              <Button
                variant="contained"
                size="small"
                startIcon={<CallIcon />}
                href="tel:+911234567890"
              >
                Call
              </Button>

              <Button
                variant="outlined"
                size="small"
                startIcon={<DirectionsIcon />}
                href={mapsLink}
                target="_blank"
              >
                Directions
              </Button>

              <Tooltip title={copyTooltip}>
                <IconButton size="small" onClick={handleCopy}>
                  <ContentCopyIcon />
                </IconButton>
              </Tooltip>

              <Tooltip title="Share">
                <IconButton size="small" onClick={handleShare}>
                  <ShareIcon />
                </IconButton>
              </Tooltip>
            </Box>
          </div>

          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1779.4504254875983!2d75.76777249061368!3d26.87489102020846!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjbCsDUyJzI5LjciTiA3NcKwNDYnMDQuMSJF!5e0!3m2!1sen!2sin!4v1749559079015!5m2!1sen!2sin"
            width="100%"
            height="400"
            style={{ border: 0, borderRadius: "12px" }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
      </Grid>
    </Box>
  );
};

export default Location;
